import _ from "lodash";
import React, { useState } from "react";

import { Button } from "@toddle-edu/ds-web";
import classNames from "classnames";

import classes from "./CasVisitorSignup.scss";
import Step1 from "./Step1";
import Step2 from "./Step2";

const CasVisitorSignup = props => {
  const {
    headerStyle,
    subTextStyle,
    data,
    updateInputField,
    onVisitorLoginLink,
    renderTradeMarkText,
    handleSignIn,
  } = props;

  const [currentStep, setCurrentStep] = useState(1);
  const {
    password,
    visitorsOrganizationName: organizationName,
    firstName,
    lastName,
  } = data;

  const onBackClick = () => {
    setCurrentStep(currentStep - 1);
  };

  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return <Step1 updateInputField={updateInputField} data={data} />;
      case 2:
        return (
          <Step2
            onBackClick={onBackClick}
            data={data}
            updateInputField={updateInputField}
          />
        );
      default:
        return null;
    }
  };

  const onActionButtonClick = () => {
    switch (currentStep) {
      case 1:
        setCurrentStep(2);
        break;
      case 2:
        handleSignIn();
        break;
      default:
        break;
    }
  };

  const isActionButtonDisabled = () => {
    switch (currentStep) {
      case 1:
        return _.isEmpty(password);
      case 2:
        return (
          _.isEmpty(firstName) ||
          _.isEmpty(lastName) ||
          _.isEmpty(organizationName)
        );
      default:
        return true;
    }
  };

  return (
    <div className={classes.container}>
      <div style={headerStyle}>{`Sign up for Toddle`}</div>
      <div style={subTextStyle}>{`Visitor sign-up`}</div>
      <div className={classes.innerContainer}>{renderStep()}</div>
      <div className={classes.bottomContainer}>
        <div className={classNames(classes.accountText, "text-body-1")}>
          {`Already have an account on Toddle?`}
          <div
            className={classNames(classes.signInText, "text-label-2")}
            onClick={onVisitorLoginLink}
          >{`Sign in`}</div>
        </div>
        <Button
          onClick={onActionButtonClick}
          disabled={isActionButtonDisabled()}
        >
          {_.isEqual(currentStep, 1) ? "Next" : "Sign up"}
        </Button>
      </div>
      {renderTradeMarkText({
        align: "left",
      })}
    </div>
  );
};

export default CasVisitorSignup;
